<template>
  <div>

    <!-- <h2 class="mb-4">Daftar Work Order</h2> -->
	<b-card no-body class="mb-3 pl-3 pr-3 pt-3 pb-3">
		<h2>Daftar Work Order</h2>
	</b-card>

    <panel class="" :noExpand="true">
      <template slot="header">
        <h4 class="panel-title">Filter</h4>
      </template>
      <div class="row outerBox filterBox" style="padding:0">
        <div class="col row">
          <div class="col-md-3 mt-2" :class="mobile ? 'pt-20' : ''">
            <label for="partshopCode">Cari</label>
            <input type="text" class="form-control" v-on:keyup.enter="vue_universal_table.update++" placeholder="Ketik teks" style="height: 43px;" v-model="filter.search">
          </div>
          <div class="col-md-3 mt-2" :class="mobile ? 'pt-20' : ''">
            <label for="partshopCode">Tanggal</label>
            <flat-pickr
              v-model="selected.date"
              :config="rangeConfig"
              placeholder="Pilih Tanggal"
            ></flat-pickr>
          </div>
          <div class="offset-md-3 col-md-3 mt-2" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
            <button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="vue_universal_table.update++">Filter</button>
          </div>
        </div>
      </div>
    </panel>

	<div class="row">
		<div class="col-md mt-2">
			<SmallStats
				title="Total Step Bengkel"
				:value="statsData ? numberWithCommas(statsData.totalStep) : 'Loading...'"
				background_color="#fff"
				:border_color="'#fff'"
				:align="'left'"
				class="shadow"
			></SmallStats>
		</div>
		
		<div class="col-md mt-2">
			<SmallStats
				title="Total Pekerjaan Bengkel Selesai"
				:value="statsData ? numberWithCommas(statsData.stepDone) : 'Loading...'"
				background_color="#fff"
				:border_color="'#fff'"
				:align="'left'"
				class="shadow"
				
			></SmallStats>
		</div>
		<div class="col-md mt-2">
			<SmallStats
				title="Average Finish Work Order"
				:value="statsData ? statsData.strTime : 'Loading...'"
				background_color="#fff"
				:border_color="'#fff'"
				:align="'left'"
				class="shadow"
			></SmallStats>
		</div>
	</div>
	<div class="row">
		<div class="col-md mt-2">
			<SmallStats
				title="Total Gambar Epoxy Belum Komplit"
				:value="statsData ? numberWithCommas(statsData.totalPendingEpoxy) : 'Loading...'"
				background_color="#fff"
				:align="'left'"
				:border_color="'#fff'"
				:hover="true"
				@emitClick="filterFunction('pendingEpoxy')"
				class="shadow"
			></SmallStats>
		</div>
		<div class="col-md mt-2">
			<SmallStats
				title="Total Gambar Epoxy Komplit"
				:value="statsData ? numberWithCommas(statsData.totalEpoxyDone) : 'Loading...'"
				background_color="#fff"
				:align="'left'"
				:border_color="'#fff'"
				:hover="true"
				@emitClick="filterFunction('epoxyDone')"
				class="shadow"
			></SmallStats>
		</div>
		<div class="col-md mt-2">
			<SmallStats
				title="Ongoing Step Bengkel"
				:value="statsData ? numberWithCommas(statsData.pendingStep) : 'Loading...'"
				background_color="#fff"
				:border_color="'#fff'"
				:align="'left'"
				:hover="true"
				@emitClick="filterFunction('ongoingStep')"
				class="shadow"
			></SmallStats>
		</div>
		
	</div>

	<div class="mt-3">
		<b-card no-body class="p-20">
			<h5>Legend :</h5>
			<div class="row ">
				<div class="row mt-2 col-md-4 col-12">
					<div class="col-2">
						<div
							style="border: 1px solid black;border-radius:20px;width:1em;height:1em;background-color:#e88d58"
						></div>
					</div>
					<div class="col-8 ">
						<h6>Gambar Epoxy Belum Komplit</h6>
					</div>
				</div>
				<div class="row mt-2 col-md-4 col-12">
					<div class="col-2">
						<div
							style="border: 1px solid black;border-radius:20px;width:1em;height:1em;background-color:#f8ff6b"
						></div>
					</div>
					<div class="col-8">
						<h6>Gambar Epoxy Komplit</h6>
					</div>
				</div>
				<div class="row mt-2 col-md-4 col-12">
					<div class="col-2">
						<div
							style="border: 1px solid black;border-radius:20px;width:1em;height:1em;background-color:#6bff6b "
						></div>
					</div>
					<div class="col-8 ">
						<h6>Pekerjaan Bengkel Selesai</h6>
					</div>
				</div>
			</div>
		</b-card>
	</div>

	<div class="row mt-3 mb-3">
		<div class="col-6 offset-6">
			<button class="btn btn-primary w-100" @click="scan">Scan Barcode</button>
		</div>
	</div>

	<b-card no-body class="mt-3 pl-3 pr-3 pt-3 pb-3" v-if="!mobile">
		<vue-universal-table
			:buttons="vue_universal_table.buttons"
			:dummy_table="false"
			:filter="filter"
			:update="vue_universal_table.update"
			api_url="/api/v1/workorder/listing/step"
			:fields="vue_universal_table.fields"
			:row_style_condition="{
				'epoxyOngoing == true': 'background-color : #e88d58',
				'epoxyComplete == true': 'background-color: #f8ff6b',
				'stepDone == true': 'background-color : #6bff6b'
			}"		
			:process_data="vue_universal_table.process_data"
			:disable_sort="false"
			@onLihatWorkOrder="viewDetailWO"
			@onScanBarcode="scan"
		></vue-universal-table>
	</b-card>
	<div v-else class="bg-white rounded">
		<vue-universal-table
		
			:buttons="vue_universal_table.buttons"
			:dummy_table="false"
			:filter="filter"
			:update="vue_universal_table.update"
			api_url="/api/v1/workorder/listing/step"
			:fields="vue_universal_table.fields"
			:row_style_condition="{
				'epoxyOngoing == true': 'background-color : #e88d58',
				'epoxyComplete == true': 'background-color: #f8ff6b',
				'stepDone == true': 'background-color : #6bff6b'
			}"		
			:process_data="vue_universal_table.process_data"
			:disable_sort="false"
			@onLihatWorkOrder="viewDetailWO"
			@onScanBarcode="scan"
			:mobileVer="true"
		></vue-universal-table>
	</div>
  </div>
</template>

<script>
	import moment from 'moment'
	import Multiselect from 'vue-multiselect'
	import SmallStats from '@/components/smallStats'

  	export default {
		data () {
			const start = moment().subtract(6, 'months').startOf('month').format('YYYY-MM-DD');
			let end  = new moment().endOf('month').format('YYYY-MM-DD')

			let filter =  {
				start: start,
				end: end,
				search : '',
				completed : null
			}

			return {
				mobile : this.isMobile(),
				data : null,
				showStatus :false,
				woStatus : null,
				woStatusLog : null,
				logName : null,
				filter: filter,
				meta : null,
				data: null,
				mobile : this.isMobile(),
				selected : {
					date : `${filter.start} to ${filter.end}`,
				},
				rangeConfig: {
					mode: 'range',
					altInput: true,
					altInputClass: 'form-control input flatpickr-input w-100',
					animate: !this.isRTL()
				},
				showNewUserModal : false,
				apiLoading: true,
				vue_universal_table : {
					update: 0,
					buttons : [
						{
							title : 'LihatWorkOrder',
							class : 'btn-outline fas fa-eye border border-secondary'
						}
					],
					fields : [{
						title : 'No Wo',
						variable :'no_wo'
					},{
						title : 'No Pol',
						variable :'no_pol'
					},{
						title : 'Car Name',
						variable :'car_name'
					},{
						title : 'Step Bengkel',
						variable :'step_bengkel'
					},{
						title : 'Jumlah Pengerjaan',
						variable :'jumlah_pengerjaan'
					},{
						title : 'Pending Parts',
						variable :'pending_parts'
					},{
						title : 'Gambar Epoxy',
						variable :'gambar_epoxy'
					},{
						title : 'Tgl Mulai Perngerjaan',
						variable :'tgl_mulai_pengerjaan'
					},{
						title : 'Tgl Masuk Mobil',
						variable : 'tgl_masuk_mobil'
					}],
					process_data : `
						for(var i = 0 ; i < data.length ; i++) {
							let noEpoxy = data[i].gambar_epoxy.split('/')
							noEpoxy = noEpoxy.map(x => parseInt(x))
							let stepBengkel = data[i].step_bengkel.split('/')

							data[i].epoxyComplete = data[i].gambar_epoxy != '0/0' && noEpoxy[0] == noEpoxy[1] ? true : false
							data[i].epoxyOngoing = data[i].gambar_epoxy != '0/0' && noEpoxy[0] < noEpoxy[1] ? true : false

							data[i].stepDone = data[i].step_bengkel != '0/0' && stepBengkel[0] == stepBengkel[1] ? true : false
						}
					`
				},
				statsData : null,
				data : null
			}
    	},
		components : {
			Multiselect,
			SmallStats
		},
		mounted	() {
			this.getDataStats()
		},
		methods : {
			emitData (data) {
				this.data = data
			},
			filterFunction(filterType) {
				// alert(filterType )
				this.filter.search = filterType
				this.vue_universal_table.update++;
			},
			scan () {
				this.$router.push({name : 'Scanner'})
			},
			async getDataStats () {
				this.statsData = null
				let url = '/api/v1/workorder/listing/step/stats'
				url = await this.processFilter(url , this.filter)
				this.$http.get(url)
				.then((resp) => {

					let data = resp.data.data

					let hours = Math.floor(data.averageTimeTaken / 60);
					let days = Math.floor(hours / 24)
					let restOfHours = hours - (days * 24)
					

					data.strTime = `${days} Days ${restOfHours} Hours`
					this.statsData = data
				})
				.catch((err) => {
					console.log(err)
				})
			},
			isiPage(page) {
				this.page = page
			},
			viewDetailWO (x) {
				x = JSON.parse(x);
				// this.$store.state.woFilterLast = {
				// 	filter : this.filter,
				// 	page : this.page
				// }

				let pathName = 'WorkOrderDetail'
				if(x.version > 1)
					pathName += `V${x.version}`

				this.$router.push({name : pathName, params : {type : 'step'}, query: {wo:x.no_wo.replace(/"/g, "")}})
			},
			processFilter (urlString , filter) {
				let keys = Object.keys(filter)
				let startQuery = '?'
				for(var i = 0 ; i < keys.length ; i++ ) {
				if(filter[keys[i]] && filter[keys[i]] != '')
					startQuery += `${keys[i]}=${filter[keys[i]]}&`
				}

				return urlString + startQuery
			}
		},
		watch : {
			'selected.date'(){
				var date = this.selected.date.split(" to ");
				this.filter.start = date[0]
				this.filter.end = date[1] ? date[1] : date[0]
			},
			'vue_universal_table.update' : function () {
				this.getDataStats()
			}
		}
  }
</script>

<style scoped>
	.hoverStatus:hover {
		background-color: #999;
	}

	.display-none {
		display: none;
	}
</style>